import { Input, styled } from "@mui/material";

const StyledInputField = styled(Input)(({ theme }) => {
  return {
    marginTop: "5px",
    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      borderRadius: theme.shape.borderRadius,
      "& input ": {
        // padding: "9px",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "24px",
      },
      // pr: 0,
    },
  };
});

export default StyledInputField;